import { useState } from 'react';
import useWalletIsConnected from 'src/hooks/useWalletIsConnected';
import { useAllWalletBalances } from 'src/hooks/query/walletBalances/useWalletBalance';
import { EarnProductsByAsset } from 'src/hooks/useEarnProduct';
import NumLib from 'src/utils/NumLib';

export function useEarnProductByAssetData(info: EarnProductsByAsset) {
	const [showAccordion, setShowAccordion] = useState(false);
	const walletIsConnected = useWalletIsConnected();
	const allWalletBalances = useAllWalletBalances();

	const handleToggleExpanded = () => {
		setShowAccordion(!showAccordion);
	};

	const shouldShowWalletBalance = (spotMarketSymbol: string): boolean => {
		const balance = allWalletBalances.get(spotMarketSymbol);
		if (!balance) return false;

		const notionalValue = balance.quote.toNum();
		const baseValue = balance.base.toNum();

		// Show if notional value >= $0.1
		if (notionalValue >= 0.1) return true;

		// Show if base value is above 4 decimal places (> 0.0001)
		if (baseValue > 0.0001) return true;

		return false;
	};

	const getWalletBalance = (spotMarketSymbol: string): string => {
		const balance = allWalletBalances.get(spotMarketSymbol)?.base;
		if (!balance) return '0';

		const numericValue = balance.toNum();

		return NumLib.formatNum.toDecimalPlaces(numericValue, 4, true);
	};

	const aprStr =
		info.apyToShow !== undefined
			? info.highestApyProductType === 'strategy_vaults' && info.apyToShow > 30
				? '> 30%'
				: !isFinite(info.apyToShow) || info.apyToShow > 10000
					? '> 10,000%'
					: info.apyToShow < 0.01
						? '< 0.01%'
						: `${info.apyToShow.toFixed(2)}%`
			: '0.00%';

	return {
		showAccordion,
		walletIsConnected,
		handleToggleExpanded,
		shouldShowWalletBalance,
		getWalletBalance,
		aprStr,
	};
}
